import useSWR from 'swr';
import { getCategories, getSubCategories, getTests } from '../firebase/webflow-test-collection';

export const useTests = () => {
  const { data, error } = useSWR('/tests', getTests, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    refreshInterval: 0
  });

  return {
    isLoading: !data && !error,
    error,
    data
  };
};

export const useCategories = () => {
  const { data, error } = useSWR('/categories', getCategories, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    refreshInterval: 0
  });

  return {
    isLoading: !data && !error,
    error,
    data
  };
};

export const useSubCategories = () => {
  const { data, error } = useSWR('/sub-categories', getSubCategories, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    refreshInterval: 0
  });

  return {
    isLoading: !data && !error,
    error,
    data
  };
};
